import type { AlertConfigurationRule } from '@rtkwlf/rendall';

function updateAlertConfigurationRules(
  allRules: unknown[],
  updatedRule: unknown,
  updatedRuleIndex: number | undefined,
) {
  if (updatedRuleIndex === undefined) {
    return [...allRules, updatedRule];
  }

  const updatedAllRules = [...allRules];
  updatedAllRules[updatedRuleIndex] = updatedRule;
  return updatedAllRules;
}

export const useUpdateAlertConfiguration =
  () =>
  (
    ruleConfig: AlertConfigurationRule,
    updatedRule: unknown,
    updatedRuleIndex?: number,
  ): AlertConfigurationRule & { version: number } => {
    const updatedRuleConfigData = updateAlertConfigurationRules(
      ruleConfig.data,
      updatedRule,
      updatedRuleIndex,
    );

    return {
      // the alert config coming from server will always have a version, we need to fix the type in rendall, for now assert that it has one
      ...((ruleConfig ?? {}) as AlertConfigurationRule & { version: number }),
      data: updatedRuleConfigData,
    };
  };
